import React from 'react';
import PropTypes from 'prop-types';
import { StyledSubCardActivityQuiz, Column } from './style';
import { ProgressCircle, Text } from '../../../atoms';

const SubCardActivityQuiz = ({ subType, activity }) => {
  const secToMin = (sec) => {
    if (sec < 60) return `${Math.round(sec)}s`;
    return `${Number.isInteger(sec) ? Math.round(sec / 60) : 0}min`;
  };

  return (
    <StyledSubCardActivityQuiz className={`${subType || ''}`}>
      {subType === 'scorm-no-quiz' && (
        <>
          <Text type="statistics-heading">Quiz non disponibile</Text>
          <Text type="b4">L'attività SCORM non prevede il quiz finale</Text>
        </>
      )}
      {subType === 'scorm-no-info' && (
        <>
          <Text type="statistics-heading">Punteggio del quiz</Text>
          <Text type="b4">Punteggio del quiz finale non rilevato</Text>
        </>
      )}
      {subType === 'scorm-with-quiz' && (
        <>
          <div>
            <Text type="statistics-heading">Punteggio del quiz</Text>
            <Text type="b4">
              Punteggio del quiz finale incorporato nello SCORM
            </Text>
          </div>
          <ProgressCircle progress={activity?.quiz_score || 0} size={58} />
        </>
      )}
      {subType === 'quiz' && (
        <>
          <div>
            <Text type="statistics-heading">Punteggio del quiz</Text>
            <Column>
              <Text type="b4">
                Tempo di permanenza:{' '}
                {activity?.duration > 0 ? secToMin(activity?.duration) : '-'}
              </Text>
              <Text type="b4">Tentativi: {activity?.quiz_tentatives || 0}</Text>
            </Column>
          </div>
          <ProgressCircle progress={activity?.quiz_score || 0} size={58} />
        </>
      )}
    </StyledSubCardActivityQuiz>
  );
};

SubCardActivityQuiz.propTypes = {
  subType: PropTypes.oneOf([
    'quiz',
    'scorm-with-quiz',
    'scorm-no-quiz',
    'scorm-no-info',
  ]).isRequired,
  activity: PropTypes.object.isRequired,
};

export default SubCardActivityQuiz;
